export default {
  bannersState: {
    ready: false,
    error: false,
    raw: [],
    mainCarousel: [],
    components: [],
    categoriesMainCarousel: [],
    categories: [],
  },
  sectionState: {
    ready: false,
    error: false,
    raw: [],
    section: [],
    components: [],
  },
  applicationState: {
    geo: {
      cities: {
        data: [],
        isReady: false,
        error: false,
      },
      localities: {
        data: [],
        isReady: false,
        error: false,
      },
    },
    iconsByLink: {
      default: 'fas fa-question',
      'url-youtube': 'fab fa-youtube',
      'url-facebook': 'fab fa-facebook',
      'url-linkedin': 'fab fa-linkedin',
      'url-instagram': 'fab fa-instagram',
      'url-twitter': 'fab fa-twitter',
      'url-blog': 'fab fa-blogger',
    },
    amenitiesIcons: {
      default: 'fas fa-question',
      bus: 'fas fa-bus',
      hotel: 'fas fa-hotel',
      vuelo: 'fas fa-plane',
      asistencia: 'fas fa-briefcase-medical',
      traslados: 'fas fa-car',
    },
    nombre: '',
    applicationId: '',
    paisId: '',
    tipoAplicacionId: '',
    activa: '',
    navigation: {
      actualModule: 'paquetes',
    },
    header: {
      telefono: '',
      email: '',
      idAgencia: '',
      numeroWhatsapp: '',
    },
    navBar: [],
    footer: {
      nombre: '',
      cuit: '',
      telefono: '',
      horarioAtencion: '',
      email: '',
      direccion: '',
      acercaDe: '',
      legajo: '',
    },
    cities: [],
  },
  packages: {
    original: [],
    filtrados: [],
    details: {
      isReady: false,
      data: null,
      paxQuantity: 0,
    },
  },
  offers: {
    original: [],
    filtrados: [],
  },
  promociones: [],
};
